import script from "./CounterIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CounterIcon.vue?vue&type=script&lang=ts&setup=true"

import "./CounterIcon.vue?vue&type=style&index=0&id=a82a4384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a82a4384"]])

export default __exports__